/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.MembershipTypes {
    "use strict";
    import MembershipType = Meevo.Model.MembershipType;

    export class MembershipTypesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        public isMarketPricingAvailable: boolean = false;
        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $scope: ng.IScope,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityChecker: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected rootScope: ng.IRootScopeService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate) {

            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityChecker,
                trackingService, null, false);

            this.initializeSections();
            this.$scope.$watch(() => {
                this.isLoading ? this.busyService.start() : this.busyService.stop();
            });
        }

        checkMarketPricing(): ng.IPromise<any> {
            return this.securityChecker.checkSecurityItem(Meevo.Components.Common.SecurityKeys.MANAGEMENT_MARKETPRICING + Meevo.Components.Common.SecurityParts.KEY_PART_READ).then((item: Model.SecurityItem) => {
                if (item.roleSecurityAccess === Model.SecurityAccessEnum.Grant && item.moduleSecurityAccess === Model.SecurityAccessEnum.Grant) {
                    this.isMarketPricingAvailable = true;
                }
            });
        }

        initializeContext(): void {
            // initialize end points
            this.baseEndpoint = this.appSettings.API_ENDPOINTS.membershipTypes;
            // initialize templatepaths
            this.sectionTemplatePath = "app/plugins/membershipTypes/sectionViews/";

            // initialize entity type which is used in location exclusion.
            this.entityType = 'MembershipType';

            this.buildCrudSecurityKeys(this.securityKeys.MEMBERSHIP_MEMBERSHIPTYPE_TAB_MAIN);
        }

        initializeSections(): void {
            let baseSectionProps: Meevo.Model.ISectionParamsExtendedDataService = {
                sectionId: 0,
                displayNameContentKey: '',
                template: '',
                isPrimarySection: false,
                handlesOwnCrud: false,
                baseEndpoint: '',
                sectionEndpoint: '',
                loggingService: this.loggingService,
                dataService: this.dataService,
                busyService: this.busyService,
                $translate: this.$translate,
                sectionSecurityKey: ''
            };

            this.initializeContext();
            // Adding sections items that represent areas in the maintenance form
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MEMBERSHIP_MEMBERSHIPTYPE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(
                    _.extend({}, baseSectionProps, {
                    displayNameContentKey: 'SECTION_MAIN',
                    template: 'main.html',
                    isPrimarySection: true,
                    baseEndpoint: this.baseEndpoint,
                    identityService: this.identityService,
                    noun: Meevo.Model.NounEnum.MembershipTypeMain,
                    sectionSecurityKey: this.securityKeys.MEMBERSHIP_MEMBERSHIPTYPE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                })));
            }

            if (!this.isApplicationModeCO() || !this.isSingleLocation) {
                this.checkMarketPricing().then(() => {

                    if (this.isMarketPricingAvailable && this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MEMBERSHIP_MEMBERSHIPTYPE_TAB_UNGRANDFATHERING + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                        this.sections.push(new UngrandfatherSection(
                            _.extend({}, baseSectionProps, {
                                displayNameContentKey: 'SECTION_UNGRANDFATHER',
                                template: 'ungrandfather.html',
                                baseEndpoint: this.baseEndpoint,
                                identityService: this.identityService,
                                modalService: this.modalService,
                                noun: Meevo.Model.NounEnum.Ungrandfathering,
                                sectionSecurityKey: this.securityKeys.MEMBERSHIP_MEMBERSHIPTYPE_TAB_UNGRANDFATHERING + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                            })
                        ));
                    }
                });
            }
            
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
            this.availableAtLocations = model.availableAtLocations;
        }

        save(): angular.IPromise<any> {
          return super.save();
        }

        get showDelete(): boolean {
            return false;
        }
 
    }
}